export default __webpack_public_path__ + "static/Innago-animated-ui-282b9eb807ad021bb492e8ad96e877e5.svg";